import { constraintText, evidenceText, t, type Lang } from "./i18n";

export { evidenceText };
import type { Profile, Scored, Signal } from "./types";
import { BAND_KEYS, SENTENCE_ORDER } from "./signals";

/** Фраза о погоде словами — то, что человек узнаёт про свой день. */
export function toSentence(place: string, signals: Signal[], lang: Lang): string {
  const by = new Map(signals.map((s) => [s.key, s]));
  const parts: string[] = [];
  for (const k of SENTENCE_ORDER) {
    const s = by.get(k);
    if (s) parts.push(evidenceText(s, lang));
    if (parts.length >= 3) break;
  }
  if (parts.length === 0) {
    const band = signals.find((s) => BAND_KEYS.includes(s.key));
    if (band) parts.push(evidenceText(band, lang));
  }
  const out = [place, ...parts].join(", ");
  return out.charAt(0).toUpperCase() + out.slice(1) + ".";
}

/** Почему играет именно этот трек. Оригинал этого сказать не мог — выбор был случайным. */
export interface BlendTerm { tag: string; weight: number; matched: boolean }

/** Профиль как взвешенная смесь — то, что движок на самом деле посчитал. */
export function blend(p: Profile, s: Scored, n = 8): BlendTerm[] {
  const max = Math.max(...p.tags.values(), 1);
  const hit = new Set(s.matched.tags);
  return [...p.tags.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, n)
    .map(([tag, w]) => ({ tag, weight: w / max, matched: hit.has(tag) }));
}

export function explain(p: Profile, s: Scored, lang: Lang): { because: string[][]; matched: string } {
  const because = p.drivers.slice(0, 4).map((d) => [
    evidenceText(d, lang),
    [...d.tags.slice(0, 2), ...d.constraints.map((c) => constraintText(c, lang))].join(", "),
  ]);

  const bits: string[] = [];
  if (s.matched.tags.length) bits.push(s.matched.tags.slice(0, 4).join(", "));
  if (s.matched.speed && p.speed) bits.push(constraintText(`speed:${p.speed}`, lang));
  if (s.matched.vocal && p.vocal) bits.push(constraintText(`vocal:${p.vocal}`, lang));
  if (s.matched.acoustic && p.acoustic) bits.push(constraintText(`acoustic:${p.acoustic}`, lang));

  return { because, matched: bits.length ? bits.join(" · ") : t(lang).byProfile };
}
